module.exports = __webpack_public_path__ + "img/BIT_white33.fb6b471f.jpg";